import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyList,
  PolicySectionTitle,
  PolicyTable,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const PrivacyJa = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "ja";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          JA
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/privacy">EN</Link>
            </li>
            <li className="selected">
              <em>JA</em>
            </li>
            <li>
              <Link to="/policy/vi/privacy">VI</Link>
            </li>
            <li>
              <Link to="/policy/th/privacy">TH</Link>
            </li>
            <li>
              <Link to="/policy/id/privacy">ID</Link>
            </li>
            <li>
              <Link to="/policy/es/privacy">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>pregnancy&amp;baby プライバシーポリシー</PolicyTitle>

      <PolicyVersion>
        施行日：[2026年9月21日]
        <br />
        最終更新日：[2026年8月25日]
      </PolicyVersion>
      <PolicyText>
        株式会社Connecti（以下「Connecti」「当社」または「当社ら」といいます。）は、
        <strong>pregnancy&amp;baby</strong>
        をご利用になる皆さまのプライバシーを尊重し、個人情報を適切かつ安全に取り扱うことを重要な責務と考えています。
      </PolicyText>
      <PolicyText>
        本プライバシーポリシーは、当社がどのような個人情報を取得し、どのような目的で利用するか、個人情報をどのように共有または移転する場合があるか、どのくらいの期間保有するか、また利用者がどのような権利を有するかについて説明するものです。
      </PolicyText>
      <PolicyText>
        本プライバシーポリシーは、<strong>pregnancy&amp;baby</strong>
        のモバイルアプリケーション、ウェブサイトおよびこれらに関連する製品・サービス（以下、総称して「本サービス」といいます。）に適用されます。
      </PolicyText>
      <PolicyText>
        当社は、必要に応じて本プライバシーポリシーを変更することがあります。重要な変更を行う場合には、適用される法令に従い、本サービス内での通知、電子メールその他適切な方法によりお知らせします。また、法令上必要な場合には、変更内容について利用者の同意を取得します。
      </PolicyText>

      <PolicySectionTitle>1. 取得する個人情報</PolicySectionTitle>
      <PolicyText>
        当社は、利用者から直接提供される情報、本サービスの利用に伴い自動的に取得される情報、および第三者の認証サービスから提供される一定の情報を取得する場合があります。
      </PolicyText>

      <PolicyArticleTitle>
        1.1 アカウントおよびプロフィール情報
      </PolicyArticleTitle>
      <PolicyText>
        利用者がアカウントを作成または利用する際、当社は以下の情報を取得する場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>メールアドレス</li>
        <li>生年</li>
        <li>ニックネーム</li>
        <li>プロフィール写真</li>
        <li>居住地域</li>
        <li>言語</li>
        <li>タイムゾーン</li>
      </PolicyHyphenList>
      <PolicyText>
        実際に取得する情報は、利用する機能やアカウントの登録方法によって異なる場合があります。
      </PolicyText>

      <PolicyArticleTitle>1.2 ソーシャルログイン情報</PolicyArticleTitle>
      <PolicyText>
        利用者は、以下のサービスを利用してアカウントを作成またはログインすることができます。
      </PolicyText>
      <PolicyHyphenList>
        <li>Google</li>
        <li>Apple</li>
      </PolicyHyphenList>
      <PolicyText>
        第三者のログインサービスを利用する場合、当社は当該サービス提供者から以下の情報を受け取る場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>アカウント識別子（ID）</li>
        <li>氏名または表示名</li>
      </PolicyHyphenList>
      <PolicyText>
        当社が受け取る情報は、各サービス提供者および利用者が当該サービスで設定した内容によって異なる場合があります。
      </PolicyText>
      <PolicyText>
        各ログインサービス提供者による情報の取扱いについては、各社のプライバシーポリシーが適用されます。
      </PolicyText>

      <PolicyArticleTitle>
        1.3 健康、妊活、妊娠およびウェルビーイングに関する情報
      </PolicyArticleTitle>
      <PolicyText>
        本サービスの一部の機能では、利用者が健康、妊活、妊娠およびウェルビーイングに関する情報を任意で入力することができます。
      </PolicyText>
      <PolicyText>
        利用する機能に応じて、以下の情報が含まれる場合があります。
      </PolicyText>

      <PolicyList>
        <li>
          <strong>妊活</strong>
          <PolicyHyphenList>
            <li>生理期間および生理周期</li>
            <li>最終月経日</li>
            <li>生理開始日および終了日</li>
            <li>排卵日</li>
            <li>排卵検査の日時</li>
            <li>排卵検査の画像および結果</li>
            <li>妊娠検査の日時</li>
            <li>妊娠検査の画像および結果</li>
            <li>基礎体温</li>
            <li>症状</li>
            <li>出血および痛みの記録</li>
            <li>服薬記録</li>
            <li>予防接種記録</li>
            <li>受診記録</li>
            <li>性交渉の記録</li>
            <li>メモその他の日記情報</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>不妊治療</strong>
          <PolicyHyphenList>
            <li>不妊治療の方法</li>
            <li>治療周期・治療回数</li>
            <li>不妊治療の開始日および終了日</li>
            <li>薬剤および注射の記録</li>
            <li>治療スケジュールおよび治療内容</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>妊娠</strong>
          <PolicyHyphenList>
            <li>出産予定日</li>
            <li>胎児のニックネーム（胎児ネーム）</li>
            <li>妊娠週数</li>
            <li>妊娠日記の情報</li>
            <li>受診記録</li>
            <li>予防接種記録</li>
            <li>体重記録</li>
            <li>エコー画像</li>
            <li>EFW、AC、FL、BPD、HC、CRL等の胎児計測値</li>
            <li>妊娠前の身長および体重</li>
            <li>体重の変化・履歴</li>
            <li>その他利用者が入力する妊娠関連情報</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>育児および産後管理</strong>
          <br />
          利用する機能に応じて、以下の子どもに関する情報を取得する場合があります。
          <PolicyHyphenList>
            <li>子どもの氏名</li>
            <li>性別</li>
            <li>生年月日</li>
            <li>出生時体重</li>
            <li>出生時身長</li>
            <li>出生時頭囲</li>
            <li>出産予定日</li>
            <li>健康診査記録</li>
            <li>予防接種記録</li>
            <li>身長、体重、頭囲等の成長記録</li>
            <li>発達評価の記録およびスコア</li>
            <li>発達に関する写真</li>
            <li>早産の有無</li>
            <li>体温記録</li>
            <li>服薬記録</li>
            <li>疾病記録</li>
          </PolicyHyphenList>
          また、産後の体重管理機能に関連して、以下の情報を取得する場合があります。
          <PolicyHyphenList>
            <li>妊娠前の身長および体重</li>
            <li>出産直前の体重</li>
            <li>産後の体重記録</li>
          </PolicyHyphenList>
          これらの情報の一部は、適用される法令上、健康情報その他の
          <strong>要配慮個人情報</strong>に該当する場合があります。
          <br />
          法令上必要な場合、当社はこれらの情報を取得または取り扱う前に、利用者から明示的または個別の同意を取得します。
        </li>
      </PolicyList>

      <PolicyArticleTitle>1.4 コミュニティ情報</PolicyArticleTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong>
        のコミュニティ機能を利用する場合、当社は以下の情報を取り扱う場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>ニックネーム</li>
        <li>プロフィール写真</li>
        <li>投稿</li>
        <li>コメント</li>
        <li>投票および投票への回答</li>
        <li>利用者が任意で投稿する画像その他のコンテンツ</li>
      </PolicyHyphenList>
      <PolicyText>
        コミュニティに投稿した情報は、他の利用者に公開される場合があります。公開領域に個人情報を投稿する際は、公開する内容について十分にご注意ください。
      </PolicyText>

      <PolicyArticleTitle>1.5 自動的に取得される情報</PolicyArticleTitle>
      <PolicyText>
        本サービスの利用に伴い、以下の技術情報および利用情報が自動的に取得される場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>端末の機種</li>
        <li>OSおよびそのバージョン</li>
        <li>アプリのバージョン</li>
        <li>言語</li>
        <li>タイムゾーン</li>
        <li>IPアドレス</li>
        <li>アプリの利用・操作情報</li>
        <li>利用またはアクセスした機能</li>
        <li>利用頻度</li>
        <li>特定機能とのインタラクション情報</li>
        <li>エラーおよび診断情報</li>
        <li>FCM登録トークンその他のプッシュ通知用トークン</li>
      </PolicyHyphenList>
      <PolicyText>
        ウェブサイトでは、必要に応じてCookieその他これに類する技術を使用する場合があります。
      </PolicyText>

      <PolicyArticleTitle>1.6 分析情報</PolicyArticleTitle>
      <PolicyText>
        当社は、利用者による本サービスの利用状況を把握し、機能およびユーザー体験を改善するため、
        <strong>Google Analytics for Firebase</strong>を利用します。
      </PolicyText>
      <PolicyText>
        分析対象となる情報には、以下が含まれる場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>アプリ利用情報</li>
        <li>セッション情報</li>
        <li>機能の利用および操作情報</li>
        <li>端末およびOSに関する情報</li>
        <li>一般的な技術情報および診断情報</li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. 個人情報の利用目的</PolicySectionTitle>
      <PolicyText>
        当社は、明確かつ正当な目的のために必要な範囲で個人情報を取り扱います。
      </PolicyText>
      <PolicyText>
        当社は、個人情報を以下の目的で利用する場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>アカウントの作成、認証および管理</li>
        <li>本サービスの提供および運営</li>
        <li>次回生理予定日、妊娠しやすい時期および排卵予定日の予測</li>
        <li>排卵検査および妊娠検査の結果の記録・分析</li>
        <li>不妊治療のスケジュールおよびリマインダーの管理</li>
        <li>妊娠週数および出産予定日の計算</li>
        <li>妊娠に関するコンテンツおよびレポートの提供</li>
        <li>胎児の成長計測値の分析</li>
        <li>妊娠中および産後の体重管理機能の提供</li>
        <li>子どもの成長・発達レポートの提供</li>
        <li>
          子どもの健康、体温、服薬、予防接種および健康診査の管理機能の提供
        </li>
        <li>
          利用者が提供した情報に基づくパーソナライズされたコンテンツおよびサービスの提供
        </li>
        <li>リマインダーおよびプッシュ通知の配信</li>
        <li>お問い合わせへの対応およびカスタマーサポート</li>
        <li>本サービスの安全性および完全性の確保</li>
        <li>不正利用または不正アクセス等の検知・防止</li>
        <li>アプリケーションの性能およびエラーの監視</li>
        <li>本サービスの利用状況の分析</li>
        <li>既存サービスの改善および新機能の開発</li>
        <li>匿名化されたデータを利用した統計および科学的研究</li>
        <li>法令の遵守および行政機関等からの適法な要請への対応</li>
      </PolicyHyphenList>
      <PolicyText>
        当社は、利用者の個人情報を販売または貸与しません。
      </PolicyText>

      <PolicySectionTitle>3. 健康情報および要配慮個人情報</PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong>
        は、妊活、生理、妊娠、母体の健康および育児に関する機能を提供しています。そのため、利用者が提供する情報の一部は、日本の個人情報保護法その他適用される法令上、
        <strong>要配慮個人情報</strong>
        その他慎重な取扱いを要する情報に該当する場合があります。
      </PolicyText>
      <PolicyText>
        当社は、利用者が選択した機能を提供するため、本プライバシーポリシーその他の方法により利用者に通知した目的のため、または法令により認められる範囲においてのみ、これらの情報を取り扱います。
      </PolicyText>
      <PolicyText>
        法令上、健康情報その他の要配慮個人情報の取得・取扱いについて本人の同意が必要となる場合には、当社は必要な同意を取得します。
      </PolicyText>
      <PolicyText>
        当社は、健康情報または要配慮個人情報を販売しません。
      </PolicyText>

      <PolicySectionTitle>
        4. 自動分析およびパーソナライズされたサービス
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong>
        の一部の機能では、利用者が提供した情報を分析し、利用者に合わせた結果を提供します。
      </PolicyText>
      <PolicyText>
        例えば、以下の目的で情報を分析する場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>次回生理予定日および妊娠しやすい時期の予測</li>
        <li>排卵予定日の予測</li>
        <li>排卵検査または妊娠検査画像の分析</li>
        <li>妊娠経過の計算</li>
        <li>胎児の成長計測値の分析</li>
        <li>母体の体重変化の分析</li>
        <li>子どもの成長および発達の分析</li>
      </PolicyHyphenList>
      <PolicyText>
        これらの分析は、本サービス内で情報提供および利用者のサポートを目的として提供するものであり、医師その他の医療専門家による診断、治療または医学的助言に代わるものではありません。
      </PolicyText>

      <PolicySectionTitle>5. プッシュ通知および各種お知らせ</PolicySectionTitle>
      <PolicyText>
        利用者の同意または設定に基づき、以下に関するプッシュ通知を送信する場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>サービス利用に関するリマインダー</li>
        <li>日記および健康記録に関するリマインダー</li>
        <li>妊娠または育児に関する情報</li>
        <li>サービスアップデート</li>
        <li>利用者が別途受信に同意したイベント、キャンペーンその他の情報</li>
      </PolicyHyphenList>
      <PolicyText>
        プッシュ通知を配信するため、当社はFCM登録トークンその他これに相当するプッシュ通知用トークンを取り扱います。
      </PolicyText>
      <PolicyText>
        利用者は、本サービスまたは端末の設定から、プッシュ通知の受信設定をいつでも変更することができます。
      </PolicyText>
      <PolicyText>
        任意の通知の受信を停止した場合でも、法令上認められる範囲で、本サービスの提供に必要な重要なお知らせを行う場合があります。
      </PolicyText>

      <PolicySectionTitle>6. Cookieおよび類似技術</PolicySectionTitle>
      <PolicyText>
        当社のウェブサイトでは、サービスの運営、設定の保存、利用状況の把握およびユーザー体験の改善のため、必要に応じてCookieその他これに類する技術を使用する場合があります。
      </PolicyText>
      <PolicyText>
        利用者はブラウザの設定によりCookieを管理できます。ただし、一部のCookieを無効にした場合、ウェブサイトの一部機能が正常に利用できない場合があります。
      </PolicyText>

      <PolicySectionTitle>7. 外部サービス提供者</PolicySectionTitle>
      <PolicyText>
        当社は、本サービスの運営、維持、分析および改善のため、外部サービス提供者を利用しています。
      </PolicyText>
      <PolicyTable>
        <caption className="hide">
          区分、サービス提供者、対象となる情報、利用目的
        </caption>
        <colgroup>
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col />
          <col style={{ width: "25%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">区分</th>
            <th scope="col">サービス提供者</th>
            <th scope="col">対象となる情報</th>
            <th scope="col">利用目的</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>インフラ・データ保存</td>
            <td>Amazon Web Services (AWS)</td>
            <td className="cell_left">本サービスを通じて処理される個人情報</td>
            <td className="cell_left">ホスティングおよびデータ保存</td>
          </tr>
          <tr>
            <td>コミュニケーション</td>
            <td>NHN Cloud</td>
            <td className="cell_left">連絡先・コミュニケーション関連情報</td>
            <td className="cell_left">メッセージおよびサービス案内の送信</td>
          </tr>
          <tr>
            <td>分析</td>
            <td>Google Analytics for Firebase</td>
            <td className="cell_left">アプリ利用・分析情報</td>
            <td className="cell_left">サービスの分析および改善</td>
          </tr>
          <tr>
            <td>画像処理</td>
            <td>Google Cloud Vision</td>
            <td className="cell_left">画像分析機能にアップロードされた画像</td>
            <td className="cell_left">画像分析および機能提供</td>
          </tr>
          <tr>
            <td>アプリケーション監視</td>
            <td>Sentry</td>
            <td className="cell_left">
              アプリケーションログ、エラーおよび診断情報
            </td>
            <td className="cell_left">パフォーマンス監視およびエラー追跡</td>
          </tr>
        </tbody>
      </PolicyTable>
      <PolicyText>
        外部サービス提供者は、当社にサービスを提供するために必要な範囲で情報を取り扱い、適用される契約上および法令上の義務に従います。
      </PolicyText>
      <PolicyText>
        本サービスの変更等に伴い、利用するサービス提供者が変更される場合があります。
      </PolicyText>

      <PolicySectionTitle>
        8. 個人情報を提供または共有する場合
      </PolicySectionTitle>
      <PolicyText>
        当社は、利用者の個人情報を販売または貸与しません。
      </PolicyText>
      <PolicyText>
        当社は、以下のような場合に限り、必要な範囲で個人情報を提供または共有する場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>当社の業務を代行する外部サービス提供者に取り扱いを委託する場合</li>
        <li>利用者が提供を指示し、または同意した場合</li>
        <li>
          法令、裁判所の命令または行政機関等からの適法な要請に基づき必要となる場合
        </li>
        <li>
          利用者、他の利用者、当社または本サービスの権利、安全もしくはセキュリティを保護するため合理的に必要な場合
        </li>
        <li>
          法令で認められる範囲において、合併、買収、組織再編、資金調達、事業・資産の譲渡その他これらに類する企業取引が行われる場合
        </li>
      </PolicyHyphenList>
      <PolicyText>
        また、特定の個人を合理的に識別できないよう不可逆的に匿名化された情報については、法令の範囲内で利用または共有する場合があります。
      </PolicyText>

      <PolicySectionTitle>9. 匿名化データおよび研究利用</PolicySectionTitle>
      <PolicyText>
        当社は、本サービスの利用に伴って生成された一部のデータを、統計、分析、科学的研究およびサービス改善の目的で匿名化して利用する場合があります。
      </PolicyText>
      <PolicyText>
        これには、女性の健康、妊活、妊娠、母体の健康および子どもの成長・発達に関する研究が含まれる場合があります。
      </PolicyText>
      <PolicyText>当社による匿名化は、以下を目的として実施します。</PolicyText>
      <PolicyHyphenList>
        <li>データから利用者を合理的に識別できない状態にすること</li>
        <li>データと利用者のアカウントを結び付ける識別情報を除去すること</li>
        <li>
          匿名化されたデータを利用者のアカウントまたは個人情報と再び関連付けることができない状態にすること
        </li>
        <li>
          当社が匿名化されたデータから利用者を再識別できない状態にすること
        </li>
      </PolicyHyphenList>
      <PolicyText>
        個人を再識別できないよう不可逆的に匿名化された情報については、適用される法令に従って取り扱います。
      </PolicyText>
      <PolicyText>
        <strong>
          匿名化されたデータは、研究、統計、分析およびサービス改善を目的として、期間を定めず保有する場合があります。
        </strong>
      </PolicyText>
      <PolicyText>
        個人を合理的に識別できない場合、当社は匿名化または集計された研究結果を研究機関その他のパートナーと利用または共有する場合があります。
      </PolicyText>

      <PolicySectionTitle>
        10. 個人情報の保有期間およびアカウント削除
      </PolicySectionTitle>
      <PolicyText>
        当社は、本サービスの提供、本プライバシーポリシーに定める利用目的の達成、または法令上の義務を履行するために合理的に必要な期間に限り、利用者を識別できる個人情報を保有します。
      </PolicyText>
      <PolicyList>
        <li>
          <strong>アカウントの削除</strong>
          <br />
          利用者は、本サービスに設けられた退会・アカウント削除機能または当社への申請により、アカウントを削除することができます。
          <br />
          アカウントを削除した場合、
          <PolicyHyphenList>
            <li>利用者のアカウントは終了します。</li>
            <li>
              利用者を識別できる個人情報は、適用される法令に従い削除または廃棄されます。
            </li>
            <li>
              後日新しいアカウントを作成した場合でも、以前の個人情報を再利用することはできません。
            </li>
          </PolicyHyphenList>
          ただし、法令上の義務の履行、紛争解決、不正利用の防止、契約上の権利の行使その他法令で要求または許容される場合には、一部の情報を一定期間保有することがあります。
          <br />
          第9条に記載するとおり、本サービスに関連する一部のデータは、アカウント削除前または削除手続の際に
          <strong>不可逆的に匿名化され</strong>
          、研究、統計、分析およびサービス改善を目的として期間を定めず保有される場合があります。このような匿名化された情報を利用者に再び関連付けることはできません。
        </li>
        <li>
          <strong>アプリの削除</strong>
          <br />
          端末から<strong>pregnancy&amp;baby</strong>
          アプリをアンインストールしただけでは、アカウントまたは個人情報は自動的に削除されません。
          <br />
          個人情報の削除を希望する場合は、本サービス内からアカウントを削除するか、当社に削除を申請してください。
        </li>
      </PolicyList>

      <PolicySectionTitle>11. 利用者の権利</PolicySectionTitle>
      <PolicyText>
        適用される法令に基づき、利用者は、当社が保有する自己の個人情報について、以下の権利を有する場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>個人情報または保有個人データの開示等を請求すること</li>
        <li>個人情報の内容の訂正、追加または削除を請求すること</li>
        <li>利用停止または消去を請求すること</li>
        <li>第三者への提供の停止を請求すること</li>
        <li>同意に基づく取扱いについて、同意を撤回すること</li>
        <li>その他適用される法令により認められる権利を行使すること</li>
      </PolicyHyphenList>
      <PolicyText>
        同意の撤回は、撤回前に行われた個人情報の取扱いの適法性に影響を及ぼしません。
      </PolicyText>
      <PolicyText>
        法令に基づき、権利の行使には一定の制限または例外が適用される場合があります。
      </PolicyText>
      <PolicyText>
        個人情報に関する請求またはお問い合わせは、以下までご連絡ください。
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
      <PolicyText>
        当社は、請求に対応する前に、本人確認のため合理的に必要な情報の提供をお願いする場合があります。
      </PolicyText>
      <PolicyText>
        当社は、適用される法令に従い、合理的な期間内に対応します。
      </PolicyText>

      <PolicySectionTitle>12. 安全管理措置</PolicySectionTitle>
      <PolicyText>
        当社は、個人情報への不正アクセス、紛失、盗難、不正利用、不正な開示、改ざんまたは破壊等を防止するため、合理的な技術的および組織的安全管理措置を講じます。
      </PolicyText>
      <PolicyText>
        これらには、通信時および保存時の暗号化、アクセス制御、モニタリング、脆弱性管理、社内のセキュリティ手続、個人情報へのアクセス制限等が含まれる場合があります。
      </PolicyText>
      <PolicyText>
        個人情報へのアクセスは、業務上必要な担当者に限定します。
      </PolicyText>
      <PolicyText>
        ただし、電子的な通信または保存方法について完全な安全性を保証することはできません。
      </PolicyText>
      <PolicyText>
        個人情報の漏えい等が発生した場合、当社は適切な措置を講じ、適用される法令上必要な場合には、利用者および関係当局への通知・報告を行います。
      </PolicyText>

      <PolicySectionTitle>
        13. 個人情報の保存場所および国外での取扱い
      </PolicySectionTitle>
      <PolicyText>
        株式会社Connectiは、<strong>大韓民国</strong>に所在しています。
      </PolicyText>
      <PolicyText>
        本サービスの主要なアプリケーションインフラおよび個人情報の保存には、
        <strong>
          Amazon Web
          Services（AWS）のアジアパシフィック（ソウル）リージョン（大韓民国）
        </strong>
        を利用しています。
      </PolicyText>
      <PolicyText>
        そのため、日本の利用者が本サービスを利用する場合、利用者の個人情報は大韓民国に所在するサーバーに保存される場合があります。
      </PolicyText>
      <PolicyText>
        また、<strong>pregnancy&amp;baby</strong>
        はグローバルなサービス提供者を利用しているため、一部の個人情報または技術情報が、利用者の居住国以外に所在するサービス提供者によって処理され、または当該サービス提供者からアクセスされる場合があります。
      </PolicyText>
      <PolicyText>
        該当するサービス提供者には、必要に応じて以下が含まれます。
      </PolicyText>
      <PolicyHyphenList>
        <li>Amazon Web Services</li>
        <li>Google</li>
        <li>NHN Cloud</li>
        <li>Sentry</li>
      </PolicyHyphenList>
      <PolicyText>
        当社は、外国にある第三者への個人データの提供その他国外での個人情報の取扱いについて、日本の個人情報保護法その他適用される法令に従い、必要な情報提供、本人同意の取得その他必要な措置を講じます。
      </PolicyText>
      <PolicyText>
        また、法令上必要な場合、外国における個人情報保護制度や当該提供先が講じる個人情報保護措置に関する情報を提供します。
      </PolicyText>

      <PolicySectionTitle>14. 未成年者の個人情報</PolicySectionTitle>
      <PolicyText>
        本サービスは、適用される法令に基づき、
        <strong>
          自己の個人情報の取得および取扱いについて自ら有効な同意を行うことができる年齢に達した方
        </strong>
        を対象としています。
      </PolicyText>
      <PolicyText>
        本サービスの利用または個人情報の取扱いについて親権者その他の法定代理人の同意が必要となる場合、必要な同意を得ていない方は
        <strong>pregnancy&amp;baby</strong>
        のアカウントを作成または利用することはできません。
      </PolicyText>
      <PolicyText>
        当社は、法的に有効な同意を自ら行うことができず、かつ必要な親権者等の同意を得ていない方から、故意に個人情報を取得することはありません。
      </PolicyText>
      <PolicyText>
        該当する個人情報が法令に反して当社に提供されたと考えられる場合は、
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
        までご連絡ください。当社は内容を確認し、必要に応じて当該情報の削除その他適切な措置を講じます。
      </PolicyText>
      <PolicyText>
        当社は、法令上必要な場合または合理的に必要と判断した場合、年齢制限または年齢確認のための措置を実施する場合があります。
      </PolicyText>

      <PolicySectionTitle>
        15. 利用者が登録する子どもの個人情報
      </PolicySectionTitle>
      <PolicyText>
        一部の育児機能では、親権者または法定代理人等が子どもに関する情報を入力することができます。
      </PolicyText>
      <PolicyText>これには、以下の情報が含まれる場合があります。</PolicyText>
      <PolicyHyphenList>
        <li>子どもの氏名</li>
        <li>性別</li>
        <li>生年月日</li>
        <li>出生時の身体計測情報</li>
        <li>成長情報</li>
        <li>発達情報</li>
        <li>健康診査記録</li>
        <li>予防接種記録</li>
        <li>体温</li>
        <li>服薬情報</li>
        <li>疾病情報</li>
        <li>関連する写真</li>
      </PolicyHyphenList>
      <PolicyText>
        子どもの個人情報を本サービスに入力することにより、利用者は、親権者、法定代理人その他法令上権限を有する者として、当該情報を提供および管理する権限を有していることを確認するものとします。
      </PolicyText>
      <PolicyText>
        当社は、本プライバシーポリシーに記載された目的および法令で認められる範囲においてのみ、当該情報を取り扱います。
      </PolicyText>

      <PolicySectionTitle>
        16. 第三者ログインサービスおよび外部サービス
      </PolicySectionTitle>
      <PolicyText>
        Google、Appleを利用して<strong>pregnancy&amp;baby</strong>
        にログインする場合、各サービスの利用については、それぞれのサービス提供者の利用規約およびプライバシーポリシーも適用されます。
      </PolicyText>
      <PolicyText>
        また、本サービスには第三者が運営するウェブサイト、アプリケーションまたはサービスへのリンクが含まれる場合があります。
      </PolicyText>
      <PolicyText>
        当社は、独立した第三者による個人情報の取扱いについて責任を負いません。第三者に個人情報を提供する前に、当該第三者のプライバシーポリシーをご確認ください。
      </PolicyText>

      <PolicySectionTitle>17. 個人情報の販売について</PolicySectionTitle>
      <PolicyText>
        当社は、利用者の個人情報を販売または貸与しません。
      </PolicyText>
      <PolicyText>
        また、健康、妊活、妊娠または子どもに関する個人情報を販売しません。
      </PolicyText>

      <PolicySectionTitle>18. 本プライバシーポリシーの変更</PolicySectionTitle>
      <PolicyText>
        当社は、以下の事項等を反映するため、本プライバシーポリシーを変更する場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>本サービスの変更</li>
        <li>個人情報の取扱方法の変更</li>
        <li>外部サービス提供者の変更</li>
        <li>適用される法令または規制の変更</li>
      </PolicyHyphenList>
      <PolicyText>
        変更が利用者の権利または個人情報の取扱いに重大な影響を及ぼす場合、適用される法令に従い、変更が効力を生じる前に適切な方法で通知します。
      </PolicyText>
      <PolicyText>
        法令上必要な場合には、変更内容について改めて利用者の同意を取得します。
      </PolicyText>
      <PolicyText>
        本プライバシーポリシーの冒頭に施行日および最終更新日を表示します。
      </PolicyText>

      <PolicySectionTitle>19. 個人情報に関するお問い合わせ</PolicySectionTitle>
      <PolicyText>
        本プライバシーポリシー、当社による個人情報の取扱い、または利用者の権利行使に関するお問い合わせは、以下までご連絡ください。
      </PolicyText>
      <PolicyText>
        <strong>株式会社Connecti（Connecti Co., Ltd.）</strong>
        <br />
        大韓民国
        <br />
        ソウル特別市 麻浦区 楊花路176
        <br />
        地下2階 56号
        <br />
        <strong>メール：</strong>{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>

      <PolicySectionTitle>20. 日本の利用者に関する事項</PolicySectionTitle>
      <PolicyText>
        日本の利用者の個人情報について、当社は
        <strong>個人情報の保護に関する法律（個人情報保護法／APPI）</strong>
        その他適用される日本の法令に従って取り扱います。日本の個人情報保護法は、日本国内の利用者へのサービス提供に関連して外国事業者が個人情報を外国で取り扱う一定の場合にも適用されます。（
        <a
          href="https://www.ppc.go.jp/personalinfo/legal/guidelines_tsusoku/?utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          PPC Japan
        </a>
        ）
      </PolicyText>
      <PolicyText>
        日本の利用者は、適用される個人情報保護法に基づき、当社が保有する保有個人データについて、開示、訂正・追加・削除、利用停止・消去、第三者提供の停止その他法令で認められる請求を行うことができます。
      </PolicyText>
      <PolicyText>
        当社が要配慮個人情報を取得する場合には、個人情報保護法その他適用される法令に従い、必要な同意を取得します。
      </PolicyText>
      <PolicyText>
        また、日本から外国にある第三者へ個人データを提供する場合には、適用される個人情報保護法に従い、必要に応じて外国の名称、当該外国の個人情報保護制度、提供先が講じる個人情報保護措置等に関する情報を提供し、必要な同意その他の措置を講じます。日本PPCは、本人同意を根拠として外国の第三者に個人データを提供する場合、一定の情報を本人に提供した上で同意を取得することを求めています。（
        <a
          href="https://www.ppc.go.jp/personalinfo/legal/guidelines_tsusoku/?utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          PPC Japan
        </a>
        ）
      </PolicyText>
      <PolicyText>
        個人情報の取扱いに関するお問い合わせまたは権利行使については、以下までご連絡ください。
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
    </PolicyContainer>
  );
};

export default PrivacyJa;
